import { Action } from '@ngrx/store';
import { DxFormGroup } from '../../form-group';
import { AddToUserDefinedProperty } from './helpers';
import { ON_EVENT_USER_DEFINED_PROPERTY } from './user-defined-property-keys';
import { Without } from '@digitaix/types';

export type OnEventHandler<Context, Event> = (this: Context, $event: Event) => Action | Action[];

export type OnEventMapEntry<Context = any, Event = any> = { output: string, handler: OnEventHandler<Context, Event> }

export function OnEvent<Event, Context>(output: string, handler: OnEventHandler<Context, Event>) {
  return function(target: Partial<Without<Context, keyof DxFormGroup<any>>>, propertyKey: string) {
    AddToUserDefinedProperty(target, propertyKey, ON_EVENT_USER_DEFINED_PROPERTY, { output, handler } as OnEventMapEntry)
  }
}
